// extracted by mini-css-extract-plugin
module.exports = {"coloursContainer":"GiftWithPurchaseColours_coloursContainer___shZg"};